<template>
  <div>
    <div>
      <strong>Rates ({{ isOneWayTrip ? 'One-way trip' : 'Round trip' }})</strong>
    </div>
    <p>Wheelchair Transportation: ${{ estimation.wheelchairTransportationRate.toFixed(2) }}</p>
    <p class="pl-4">
      Standard Rate: ${{ estimation.wheelchairTransportationStandardRate.toFixed(2) }}
    </p>
    <p
      v-if="!isOneWayTrip"
      class="pl-4"
    >
      Wait Time Rate: ${{ estimation.waitTimeRate.toFixed(2) }}
    </p>
    <p class="pl-4">
      Surcharge Rate: ${{ estimation.wheelchairTransportationSurchargeRate.toFixed(2) }}
    </p>
    <br>
    <p>Passenger Transportation: ${{ estimation.passengerTransportationRate.toFixed(2) }}</p>
    <p class="pl-4">
      Standard Rate: ${{ estimation.passengerTransportationStandardRate.toFixed(2) }}
    </p>
    <p
      v-if="!isOneWayTrip"
      class="pl-4"
    >
      Wait Time Rate: ${{ estimation.waitTimeRate.toFixed(2) }}
    </p>
    <p class="pl-4">
      Surcharge Rate: ${{ estimation.passengerTransportationSurchargeRate.toFixed(2) }}
    </p>
    <br>
    <div><strong>Wheelchair Transportation</strong></div>
    <p>$75.00 Base Rate</p>
    <p>First 10 miles included</p>
    <p>$3.00 per mile after 10 miles</p>
    <p>Wait time* and surcharge** rates may apply</p>
    <br>
    <div><strong>Passenger Transportation</strong></div>
    <p>$60.00 Base Rate</p>
    <p>First 10 miles included</p>
    <p>$2.50 per mile after 10 miles</p>
    <p>Wait time* and surcharge** rates may apply</p>
    <br>
    <p>
      <strong>*Wait time rates:</strong>
      <span>
        For roundtrips with drop-off locations over 25 miles from our office location in Fairfield, CA 94534 that require over 30 minutes of
        wait time, a wait time rate of $25.00 per hour billed in 15-minute increments applies.
      </span>
    </p>
    <br>
    <p>
      <strong>**Surcharge rates:</strong>
      <span>For trips with pick-up addresses over 15 miles from our office location in Fairfield, CA 94534, for each mile over 15, a surcharge
        rate of $1.50 per mile for wheelchair transportation or a surcharge rate of $1.00 per mile for passenger transportation applies.
      </span>
    </p>
    <br>
  </div>
</template>

<script setup lang="ts">
defineProps({
  estimation: {
    type: Object,
    required: true,
  },
  isOneWayTrip: {
    type: Boolean,
    default: true,
  },
});
</script>
